import { useTranslations } from '@vocab/react';
import { List, IconInfo, Text, Box } from 'braid-design-system';
import { useAtomValue } from 'jotai';
import type React from 'react';

import { usePayments } from '../../context/PaymentsProvider';
import { isStripeLoadedAtom } from '../../context/StripeProviderStore';
import translations from '../../locales.vocab';
import { savedCardInfoAtom } from '../../usecases/CreditCard/CreditCardStore';
import { isAsia } from '../../utils/isAsia';

const AsiaNoSavedCC: React.FC = () => {
  const { t } = useTranslations(translations);
  const { country, paymentMethod, savedCreditCard, creditCardForm } =
    usePayments();
  const savedCardInfo = useAtomValue(savedCardInfoAtom);
  const stripeIsLoaded = useAtomValue(isStripeLoadedAtom);
  const isCountryAsia = isAsia({ country });

  if (!savedCreditCard) {
    return <></>;
  }

  const isShowMessage =
    isCountryAsia &&
    paymentMethod === 'CreditCard' &&
    !savedCardInfo &&
    creditCardForm?.showSaveCard &&
    !savedCreditCard.isGetSavedCardsLoading &&
    stripeIsLoaded;

  return (
    <>
      {isShowMessage && (
        <div style={{ marginLeft: '-35px' }}>
          <Box marginY="medium">
            <List space="medium" type="icon" icon={<IconInfo tone="info" />}>
              <Text tone="info">{t('asia.savedcc.message')}</Text>
            </List>
          </Box>
        </div>
      )}
    </>
  );
};

export default AsiaNoSavedCC;
